import {
  SAVE_COUPON_REQUEST,
  SAVE_COUPON_SUCCESS,
  SAVE_COUPON_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };

    case SAVE_COUPON_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };

    case SAVE_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
};
